<h2 mat-dialog-title class="summary-title">
  <mat-icon svgIcon="galaxy-ai-icon" />
  {{ 'AI_SUMMARY.MODAL.TITLE' | translate: { objectName: objectName } }}
</h2>
<mat-dialog-content class="summary-content">
  @if (aiSummaryResponse$ | async; as aiSummaryResponse) {
    @if (aiSummaryIsLoading()) {
      <glxy-loading-spinner />
    } @else if (noAISummary()) {
      <glxy-alert type="tip">
        {{ aiSummaryResponse }}
      </glxy-alert>
    } @else {
      <p [innerHTML]="aiSummaryResponse"></p>
    }
  } @else {
    <glxy-loading-spinner />
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="regenerateSummary(true)">
    <mat-icon>redo</mat-icon>
    {{ 'AI_SUMMARY.MODAL.REGENERATE_SUMMARY' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="handleCancel()">
    {{ 'AI_SUMMARY.MODAL.CONFIRMATION' | translate }}
  </button>
</mat-dialog-actions>
